export default __webpack_public_path__ + "static/promote-products-89b12f480727e525b29de10b504150b6.png";